import { render } from "./PercorsiNonIniziati.vue?vue&type=template&id=23160421&scoped=true"
import script from "./PercorsiNonIniziati.vue?vue&type=script&lang=js"
export * from "./PercorsiNonIniziati.vue?vue&type=script&lang=js"

import "./PercorsiNonIniziati.vue?vue&type=style&index=0&id=23160421&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23160421"]])

export default __exports__